export const types = {
  businesses: "[GET] Businesses",
  requests: "[GET] Requests",
  addBusinesses: "[POST] Businesses",
  removeBusinesses: "[DELETE] Businesses",
  refreshBusinesses: "[POST] Businesses",
};
